import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinner } from "primeng/progressspinner";
import { EnvironmentService } from '../../@core/services/environment.service';

@Component({
  selector: 'app-empty',
  standalone: true,
  imports: [
    ButtonModule,
    DialogModule,
    TranslateModule,
    ProgressSpinner
  ], template: `
  <div class="bg-surface-50 dark:bg-surface-950 flex items-center justify-center min-h-screen min-w-[100vw] overflow-hidden">
    <p-progressSpinner styleClass="custom-spinner" strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
  </div>
    `
})
export class CallbackComponent implements OnInit {

  constructor(private oidcSecurityService: OidcSecurityService, private router: Router, private envService: EnvironmentService) { }

  async ngOnInit(): Promise<void> {
    const whiteOidc = JSON.parse(localStorage.getItem('ias-white-oidc') ?? '{}');
    const blueOidc = JSON.parse(localStorage.getItem('ias-blue-oidc') ?? '{}');

    let isWhite = false;
    let isBlue = false;
    if (whiteOidc.authStateControl) {
      isWhite = whiteOidc.authStateControl ? true : false;
    } else if (blueOidc.authStateControl) {
      isBlue = blueOidc.authStateControl ? true : false;
    }

    this.oidcSecurityService.checkAuth(undefined, isWhite ? 'ias-white-oidc' : isBlue ? 'ias-blue-oidc' : '').subscribe({
      next: ({ isAuthenticated }) => {
        if (isAuthenticated) {
          localStorage.setItem('oidc-login', isWhite ? 'ias-white-oidc' : isBlue ? 'ias-blue-oidc' : 'cognito-oidc');
          this.router.navigate(['/']);
        } else {
          console.log('redirect to login with postLogin true');
          this.router.navigate(['/auth/login'], { queryParams: { postLogin: 'true' } });
        }
      },
      error: (err) => {
        console.error('Errore durante il checkAuth', err);
        this.oidcSecurityService.logoff(isWhite ? 'ias-white-oidc' : isBlue ? 'ias-blue-oidc' : '').subscribe(() => {
          console.log('Logoff completed');
          localStorage.removeItem('oidc-login');
        });
      }
    });
  }
}
